import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import L from 'leaflet';
import { MapControl as LeafletMapControl } from 'react-leaflet';

class MapControl extends LeafletMapControl {

  componentWillMount() {
    const legend = L.control({ position: this.props.position });

    legend.onAdd = () => {
      this.container = L.DomUtil.create('div', '');
      ReactDOM.render((
        <div>
          {this.props.children}
        </div>
      ), this.container);
      return this.container;
    };

    this.leafletElement = legend;
  }

  componentWillReceiveProps(nextProps) {
    ReactDOM.render((
      <div>
        {nextProps.children}
      </div>
    ), this.container);
  }
}

MapControl.propTypes = {
  position: PropTypes.string,
};

MapControl.defaultProps = {
  position: 'bottomright'
};

export default MapControl;



/** WEBPACK FOOTER **
 ** ./core_components/MapControl/index.js
 **/